import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { X, Info, AlertTriangle, AlertCircle } from 'lucide-react';
import { useSocket } from '../context/SocketContext';

const API_URL = process.env.REACT_APP_BACKEND_URL + '/api';

const TYPE_CONFIG = {
  info:    { bg: 'rgba(59,130,246,0.15)', border: 'rgba(59,130,246,0.35)', text: '#93c5fd', Icon: Info },
  warning: { bg: 'rgba(245,158,11,0.15)', border: 'rgba(245,158,11,0.35)', text: '#fcd34d', Icon: AlertTriangle },
  error:   { bg: 'rgba(239,68,68,0.15)',  border: 'rgba(239,68,68,0.35)',  text: '#fca5a5', Icon: AlertCircle },
};

export default function BannerBar() {
  const [banner, setBanner] = useState(null);
  const [dismissed, setDismissed] = useState(false);
  const { onBannerUpdated, offBannerUpdated } = useSocket();

  // Fetch once on mount
  useEffect(() => {
    axios.get(`${API_URL}/banner`)
      .then(({ data }) => { if (data?.active) { setBanner(data); setDismissed(false); } })
      .catch(() => {});
  }, []);

  // Live update via socket when admin sets or clears banner
  useEffect(() => {
    const handle = (data) => {
      if (data?.active) { setBanner(data); setDismissed(false); }
      else { setBanner(null); }
    };
    onBannerUpdated(handle);
    return () => offBannerUpdated(handle);
  }, [onBannerUpdated, offBannerUpdated]);

  if (!banner || dismissed) return null;

  const cfg = TYPE_CONFIG[banner.type] || TYPE_CONFIG.info;
  const { Icon } = cfg;

  return (
    <div
      className="w-full px-4 py-2 flex items-center gap-2 text-sm"
      style={{ backgroundColor: cfg.bg, borderBottom: `1px solid ${cfg.border}` }}
    >
      <Icon className="w-4 h-4 flex-shrink-0" style={{ color: cfg.text }} />
      <span className="flex-1 text-xs font-medium" style={{ color: cfg.text }}>
        {banner.message}
      </span>
      <button
        onClick={() => setDismissed(true)}
        className="ml-2 p-0.5 rounded opacity-70 hover:opacity-100 transition-opacity"
        style={{ color: cfg.text }}
        aria-label="Dismiss"
      >
        <X className="w-3.5 h-3.5" />
      </button>
    </div>
  );
}
